<template>
  <div class="card Netpa-Shadow bnp-rounded m-1 ml-1 mt-2 h-100">
    <div
      class="card-header text-right text-light pb-0 position-relative"
      :class="ThemePackege"
    >
      <a
        v-if="IsMinus"
        class="float-left"
        data-toggle="collapse"
        :href="IdElement ? '#collapseExample' + IdElement : ''"
        aria-expanded="false"
        :aria-controls="IdElement ? 'collapseExample' + IdElement : ''"
        @click="IconDown = !IconDown"
      >
        <!--<i class="text-light fas fa-arrow-up ml-1"></i>
        <i class="text-light fas fa-arrow-down"></i>-->
        <i
          class="text-light ml-1"
          :class="IconDown ? 'fas fa-chevron-down' : 'fas fa-chevron-up'"
        ></i>
      </a>
      <slot name="header"></slot>
    </div>
    <div
      class="card-body text-dark text-right"
      :class="IsCollapse && IsCollapse == true ? 'collapse ' : 'collapse show'"
      v-if="IsMinus"
      :id="IdElement ? 'collapseExample' + IdElement : ''"
    >
      <slot name="content"></slot>
    </div>
    <div class="card-body text-dark text-right" v-if="!IsMinus">
      <slot name="content"></slot>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      Theme: "bg-BlueGreen",
      IconDown: this.IsCollapse ? true : false, ////true
    };
  },
  computed: {
    ThemePackege() {
      if (this.Classes) {
        return this.Classes;
      } else {
        return this.$store.state.Theme;
      }
    },
    GetTitle() {
      var curentRoot = this.$route.name;
      var Label;

      switch (curentRoot) {
        case "Accounts":
          Label = "حساب ها";
          break;

        default:
          break;
      }
      return Label;
    },
  },
  methods: {},
  components: {},
  props: ["Classes", "IsMinus", "IdElement", "IsCollapse"],
};
</script>
<style scoped>
.btn {
  border-radius: 0%;
}
.bg-BlueGreen {
  background: #435ebe;
  /* background:#566787; */
  margin-top: -2px;
}
.bnp-rounded {
  border-radius: 15px;
  overflow: hidden;
}
</style>
